import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useQuery } from '#src/hooks/graphql/useQuery.ts';
import { useApplyJonumRestriction } from '#src/hooks/useApplyJonumRestriction.ts';

import type {
  AlternativeRewardThresholdQuery,
  AlternativeRewardThresholdQueryVariables,
} from './__generated__/useAlternativeRewardThresholdReached.graphql.ts';

const ALTERNATIVE_REWARD_THRESHOLD_QUERY = gql`
  query AlternativeRewardThresholdQuery {
    currentUser {
      slug
      jonumVerification {
        id
        reward {
          used {
            eurCents
          }
          alternativeRewardThreshold {
            eurCents
          }
        }
      }
    }
  }
` as TypedDocumentNode<
  AlternativeRewardThresholdQuery,
  AlternativeRewardThresholdQueryVariables
>;

export const useAlternativeRewardThresholdReached = () => {
  const applyJonumRestriction = useApplyJonumRestriction();
  const { data } = useQuery(ALTERNATIVE_REWARD_THRESHOLD_QUERY, {
    skip: !applyJonumRestriction,
  });

  if (!applyJonumRestriction) return false;

  const reward = data?.currentUser?.jonumVerification?.reward;
  const used = reward?.used.eurCents;
  const threshold = reward?.alternativeRewardThreshold.eurCents;

  if (used == null || threshold == null) return false;

  return used >= threshold;
};
